import {SurveyForm} from '@/hooks/help';
import styles from './SurveyBody.module.scss';

const subject = [
  {key: 'feedback', desc: '만족스러운 답변이 되었습니까?'},
  {key: 'speed', desc: '답변 속도는 만족스러우셨습니까?'},
];

const radioOptions = [
  {score: 20, text: '매우불만족'},
  {score: 40, text: '불만족'},
  {score: 60, text: '보통'},
  {score: 80, text: '만족'},
  {score: 100, text: '매우만족'},
];

interface SurveyBodyProps {
  isMobile: boolean;
  surveyForm: SurveyForm;
  setSurveyForm: (form: SurveyForm) => void;
  variant?: 'layer' | 'page';
}

const SurveyBody = ({
  isMobile,
  surveyForm,
  setSurveyForm,
  variant = 'layer',
}: SurveyBodyProps) => {
  return (
    <>
      {!isMobile && (
        <p className={styles.FeedbackDescription}>
          남겨주신 의견은 서비스 품질 개선에 활용됩니다.
        </p>
      )}
      <div
        className={
          variant === 'layer'
            ? styles.FeedbackWrapper
            : styles.FeedbackWrapperPage
        }>
        <ul>
          {subject.map(({key, desc}) => (
            <li key={key}>
              <span>{desc}</span>
              <ul>
                {radioOptions.map(({score, text}) => (
                  <li key={score}>
                    <button
                      type='button'
                      name={key}
                      id={`${key}-${score}`}
                      value={score}
                      className={surveyForm[key] >= score ? styles.active : ''}
                      onClick={() => {
                        setSurveyForm({
                          ...surveyForm,
                          [key]: score,
                        });
                      }}>
                      {text}
                    </button>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SurveyBody;
